import { JsonDiscriminatorValue, JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../../../base-types";
import DataType from "../data-type";
import { JsonContentType } from "../json-content-type";
import { PropertyDefinition } from "../property-definition";

/**
 * Json property definition.
 */
@JsonObject()
@JsonDiscriminatorValue("Json")
export class JsonPropertyDefinition extends PropertyDefinition {
    @JsonProperty("content_type")
    contentType: Nullable<JsonContentType> = null;

    constructor(name: string, init?: Omit<Partial<JsonPropertyDefinition>, "name">) {
        super(name, DataType.Json);
        Object.assign(this, init);
    }
}
